import axios from "axios";
import { Message } from "element-ui";
import i18n from "@/i18n";

const defaultHeaders = {
  "Content-Type": "application/json",
  "client-src": "pcweb"
};

let baseURL = "https://gateway-dev.graspishop.com/identitysvc";
// 获取环境baseURL
switch (process.env.ISHOP_ENV) {
  case "dev":
    baseURL = "https://gateway-dev.graspishop.com/identitysvc";
    break;
  case "test":
    baseURL = "https://gateway-test.graspishop.com/identitysvc";
    break;
  case "stage":
    baseURL = "https://gateway-gray.graspishop.com/identitysvc";
    break;
  case "prod":
    // baseURL = "https://gateway-gray.graspishop.com/identitysvc";
    baseURL = "https://gateway.graspishop.com/identitysvc";
    break;
}

const instance = axios.create({
  baseURL,
  headers: defaultHeaders
});

instance.interceptors.request.use(
  config => {
    config.headers = {
      ...defaultHeaders,
      // 语言可随时切换，必须每次请求实时取值，不能并入 defaultHeaders 这个常量。
      // 只能读 i18n.locale：getLanguage() 内部会请求语言列表，在拦截器里调用会递归触发请求
      "X-Locale": i18n.locale,
      ...config.headers
    };
    return config;
  },
  error => {
    {
      Message.error(error.message);
      throw new Error(error.message);
    }
  }
);

instance.interceptors.response.use(
  response => {
    const { data = {}, status, statusText } = response;
    if (status === 200) {
      // 不做统一处理是因为要和以往的提示保持一致。
      // const codes = [0, 99, -199, -200, 98]
      // const { RetCode, RetMessage } = data
      // if(codes.includes(RetCode)) return data
      // else return Message.error(RetMessage)
      return data;
    } else if (status === 401) {
      Message.error(i18n.t('http.noPermission'));
      throw new Error(JSON.stringify(data));
    } else {
      Message.error(statusText);
      throw new Error(data);
    }
  },
  error => {
    Message.error(error.message);
    throw new Error(error.message);
  }
);
class Http {
  post(path, otherParams = {}) {
    return (data, paramsData = {}) => {
      let apiPatch = (otherParams.url || "") + path;
      return instance.post(apiPatch, data, {
        headers: {
          ...otherParams.headers,
          ...paramsData.headers
        },
        params: paramsData.data
      });
    };
  }
  get(path, otherParams = {}) {
    return (params, data = {}) => {
      let apiPatch = `${otherParams.url || ""}${path}`;
      return instance.get(apiPatch, {
        data: data.params,
        params,
        headers: data.headers
      });
    };
  }
}
export default new Http();



// WEBPACK FOOTER //
// ./src/api/http.js